export const autoLabelDatabase = [
    {
        idCode: 'fmo@@@LddTTVbvebQbrTyjUcNBfjjjjjjjjjh@Oz[PG]cAhMv\\anulMvLSnqiuFzNYwXt[c][B[iZS]SJ{lXmin}c]vLflw\\sn{Fs^{lZlGnqnt^{FGI{lYmgni`q^zfSU{jZLwnilw^zfKC{jZmOninr~zf[@',
        mf: 'C27',
        mw: 324.29699999999997,
        label: 'cholesterol',
    },
    {
        idCode: 'flm@@@LddTTVbvebyjUcNBfjjjjjjj@C~fTAwXpZC]gH[m[C]cD{lZ]Qncf]vMFxwVpfzVdwTrn{FKZ[oXw]cIkMwL{nqlwn{FkA{l[mGnqar^{F[@',
        mf: 'C19',
        mw: 228.20899999999997,
        label: 'steroid',
    },
    {
        idCode: 'fhe@@@LdbbbTReryHQmN|Fjjjjjj`@iE@TzCFCHavFMFIUjTYcFK\\npfLfeMeQ[TfLqlufMV]YoL[lEcM`',
        mf: 'C17',
        mw: 204.18699999999998,
        label: 'steroid-core',
    },
    {
        idCode: 'daDD@@qJYnnjjh@hrPwXrMvlS]STwRsMums]s@',
        mf: 'C6O2',
        mw: 104.06400000000001,
        label: 'pyranose',
    },
    {
        idCode: 'gOp`AdifMjj`OzUHwXr[iXmuMV{f[]k@',
        mf: 'C5O2',
        mw: 92.053,
        label: 'furanose',
    },
    {
        idCode: 'gOp`Adigkjj`OzUHwXr[mXmuMVzV[]s@',
        mf: 'C5O2',
        mw: 92.053,
        label: 'pyranose-core',
    },
    {
        idCode: 'gFp`AdidvjhC~aRMvLfzVK]SUny`',
        mf: 'C4O2',
        mw: 80.042,
        label: 'furanose-core',
    },
];
//# sourceMappingURL=autoLabelDatabase.js.map